import { ApiBaseData } from '@ibe/api';
import React, { JSX } from 'react';
import { FormConfig, RadioGroupElement } from '../types/types';
import FormRadioGroup from './FormRadioGroup';

interface Props {
  config: RadioGroupElement;
  keySuffix?: FormConfig['keySuffix'];
  externalData?: Record<string, unknown>;
}

const RadioGroupWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      id,
      tag,
      key,
      label,
      placeholder,
      boldLabel,
      showErrorIcon,
      disabled,
      values,
      externalDataValues,
      nonNative
    },
    externalData,
    keySuffix
  } = props;

  const finalValues =
    values ||
    ((externalData && externalDataValues ? externalData[externalDataValues] : []) as ApiBaseData[]);

  return (
    <FormRadioGroup
      id={id}
      tag={tag}
      name={`${key}${keySuffix || ''}`}
      label={label}
      boldLabel={boldLabel}
      showErrors
      placeholder={placeholder}
      showErrorIcon={showErrorIcon}
      disabled={disabled}
      values={finalValues}
      nonNative={nonNative}
    />
  );
};

export default RadioGroupWrapper;
